import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { combineLatest, map, Observable, Subscription } from 'rxjs';
import { CommonPopup } from '../common-popup/common-popup';
import { MatDialog } from '@angular/material/dialog';
import { VmMachineService } from '../../services/vm-machine.service';
import { AuthService } from 'src/app/services/auth.service';
import { DialogDelete } from 'src/app/dialog-delete/dialog-delete.component';
import { SystemService } from '../../services/system.service';
import { ConfigService } from 'src/app/shared/config';

@Component({
  selector: 'app-vm-machine',
  templateUrl: './vm-machine.component.html',
  styleUrls: ['./vm-machine.component.css']
})
export class VmMachineComponent implements OnInit {
  siteId: string;
  systemId: string;
  machineId: string;
  showBackButton = false;
  machineType: string;
  isAdmin: boolean = false;
  _isSuperAdmin: boolean = false;
  jsdVersion: string = "not aviailable";
  nodeVersion: string = "not aviailable";
  $machineArr: Observable<any>;
  vmMachineChangedSub: Subscription;
  vmMachineArr = [];
  showDeleteButton = false;

  selectedMachine: any;
  constructor(private router: Router,
    public dialog: MatDialog,
    public auth: AuthService,
    private systemService: SystemService,
    private vmService: VmMachineService,
    private config: ConfigService,
    private route: ActivatedRoute) {


    this.auth.getUser$().subscribe(userInfo => {
      this._isSuperAdmin = userInfo['isSuperAdmin']
      this.isAdmin = userInfo['roles'].admin;
    });

    combineLatest(this.route.parent.params, this.route.params, this.route.queryParams).subscribe(params => {
      this.siteId = params[0]['siteId'];
      this.systemId = params[1]['systemId'];
      this.machineId = params[1]['machineid'];
      this.machineType = params[2]['type'] || 'vend';

      this.systemService.systemSetData(this.siteId, this.systemId);
    })

    this.$machineArr = this.systemService.vmMachineChanged.pipe(map((doc: any[]) => {
      return doc.map(d => {
        return {
          ...d,
          uid: d['id'],
          url: `/dashboard/sites/${this.siteId}/system/${this.systemId}/vmmachine/${d['id']}?type=${d.type}`
        }
      })
    }));

    this.vmMachineChangedSub = this.$machineArr.subscribe((vmArr) => {

      this.selectedMachine = vmArr.find(m => m.uid == this.machineId);

      this.vmMachineArr = vmArr;
    })

  }


  async ngOnInit() {


    this.vmService.getMachineDetail(this.machineId).subscribe(data => {
      this.nodeVersion = data.data()['machineIdentification'];
      this.jsdVersion = data.data()['JSDversion'];
    })
  }

  readVersions() {
    this.vmService.readVersions(this.siteId, this.systemId, this.machineId)

  }

  showDeleteButtons(value) {
    this.showDeleteButton = value;
  }


  addCabinet() {
    const dialogRef = this.dialog.open(CommonPopup, {
      disableClose: true,
      width: '500px',
      data: {
        siteId: this.siteId,
        text: "",
        formData: {
          title: "Add New Locker Cabinet",
          inputFeilds: [
            {
              labelName: "Node ID",
              name: "nodeId",
              required: true,
              type: "number",
              specialText: ""
            }, {
              labelName: "Index",
              name: "index",
              required: true,
              type: "number",
              specialText: ""
            },
            {
              labelName: "Controlled Lights",
              name: "haveControlledLights",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Active",
                  value: true
                },
                {
                  label: "Inactive",
                  value: false
                }
              ]
            }
          ],
          buttons: [
            {
              name: "ADD",
              type: "submit",
              color: "primary",
              validate: true
            }
          ]
        }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.vmService.addCabinetToVm(this.siteId, this.systemId, this.machineId, result.value)
        // result.value.nodeId = Number(result.value.nodeId)
        // result.value.haveControlledLights = Boolean(result.value.haveControlledLights)
      }

    });

  }

  onMachine(machine) {
    console.log(machine)
    this.selectedMachine = machine;
    this.router.navigateByUrl(machine.url);
  }

  addChannel() {
    const dialogRef = this.dialog.open(CommonPopup, {
      disableClose: true,
      width: '500px',
      data: {
        siteId: this.siteId,
        text: "",
        formData: {
          title: "Add channel",
          inputFeilds: [
            {
              labelName: "Selection",
              name: "selection",
              required: true,
              type: "number",
              specialText: ""
            }
          ],
          buttons: [
            {
              name: "ADD",
              type: "submit",
              color: "primary",
              validate: true
            }
          ]
        }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log(result.value)
        this.vmService.addChannelToVm(this.siteId, this.systemId, this.machineId, result.value)
        // result.value.nodeId = Number(result.value.nodeId)
        // result.value.haveControlledLights = Boolean(result.value.haveControlledLights)
      }

    });

  }

  createSelection() {
    // event.stopPropagation();

    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "Create selection",
          message: " Are you sure to continue? ",
          class: ['warn-button', 'theme-button']
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.machineType != 'cal8') {
          this.vmService.createSelection(this.siteId, this.systemId, this.machineId);
          this.systemService.addActionLog(this.siteId, this.systemId, {
            message: `Channel mapping`,
          })
        }
        else if (this.machineType == 'cal8')
          this.vmService.createLockerSelection(this.siteId, this.systemId, this.machineId);
      }
    });


  }


  requestConfirmation(){
    
  }
  createChannelFromSelection() {
    // event.stopPropagation();

    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "Create channel from mapping",
          message: " Are you sure to continue? ",
          class: ['warn-button', 'theme-button']
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.vmService.createChannelFromSelection(this.siteId, this.systemId, this.machineId)
    });
  }

  updateChannelMapping() {
    // event.stopPropagation();

    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "Apply changes",
          message: " Are you sure to continue? ",
          class: ['warn-button', 'theme-button']
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.vmService.updateChannelMapping(this.siteId, this.systemId);
      this.systemService.addActionLog(this.siteId, this.systemId, {
        message: `Apply changes`,
      })
    });

  }

  isVendingElement(machineType) {
    if (machineType == 'vend' || machineType == 'Esplus')
      return true;
    else
      return false;
  }

  resetMachine() {
    // event.stopPropagation();

    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "Reset machine",
          message: " Are you sure to continue? ",
          class: ['warn-button', 'theme-button']
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log(result)
        this.vmService.resetMachine(this.siteId, this.systemId, this.machineId);
        this.systemService.addActionLog(this.siteId, this.systemId, {
          message: `Reset Machine ${this.machineId}`,
        })
      }
    });


  }

  resetSoldOut() {
    // event.stopPropagation();

    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "Reset sold out",
          message: " Are you sure to continue? ",
          class: ['warn-button', 'theme-button']
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log(result)
        this.vmService.resetSoldOut(this.siteId, this.systemId, this.machineId);
        this.systemService.addActionLog(this.siteId, this.systemId, {
          message: `Reset Machine ${this.machineId}`,
        })
      }
    });


  }

  collectProductElevetor() {
    // event.stopPropagation();

    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "Open hatch",
          message: " Are you sure to continue? ",
          class: ['warn-button', 'theme-button']
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log(result)

        this.vmService.collectProductElevetor(this.config.getCompanyId(), this.siteId, this.systemId, this.machineId);
        this.systemService.addActionLog(this.siteId, this.systemId, {
          message: `Collect Product from  ${this.machineId}`,
        })
      }
    });


  }

  openServiceMenu() {
    window.open(`/support/shell/${this.systemId}`, '_blank', 'width=1250,height=800,location=no,menubar=no,toolbar=no');
  }

  onBack() {
    this.router.navigate(['../../'], { relativeTo: this.route })
  }
}
